class CartItem extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.quantity = this.form.querySelector(
      'input[type="hidden"][name="quantity"]',
    );
    this.sections = this.form.querySelector(
      'input[type="hidden"][name="sections"]',
    );
    this.sellingPlan = this.form.querySelector(
      'input[type="hidden"][name="selling_plan"]',
    );
    this.dynamicElements = [
      ...this.querySelectorAll("[data-dynamic]"),
      document.querySelector("#cart-subtotal"),
    ];
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.handleAction.bind(this)),
    );
  }

  handleAction(event) {
    event.preventDefault();
    const action = event.currentTarget.dataset.action;
    switch (action) {
      case "decrement":
        this.decrementQuantity();
        break;
      case "increment":
        this.incrementQuantity();
        break;
      case "remove":
        this.removeProduct();
        break;
      case "swap":
        this.swapProduct();
        break;
    }
  }

  decrementQuantity() {
    this.quantity.value = parseInt(this.quantity.value) - 1;
    this.setLoader();
    this.handleSubmit();
  }

  incrementQuantity() {
    this.quantity.value = parseInt(this.quantity.value) + 1;
    this.setLoader();
    this.handleSubmit();
  }

  removeProduct() {
    this.quantity.value = 0;
    this.sections.value =
      "cart-item-count,cart-subtotal,cart-item-list,cart-upsells";
    this.setLoader();
    this.handleSubmit();
    if (document.querySelector("product-form[max-per-order]")) {
      setTimeout(() => {
        document.querySelector("product-form[max-per-order] form button[type='submit']").disabled = false;
      }, 750);
    }
  }

  swapProduct() {
    this.sellingPlan.value = this.getAttribute("selling-plan");
    this.setLoader();
    this.handleSubmit();
  }

  setLoader() {
    this.dynamicElements.forEach((element) => {
      element.innerHTML = loader();
    });
  }

  async handleSubmit() {
    const formData = new FormData(this.form);
    const response = await fetch(window.Shopify.routes.cart_change_url, {
      method: "POST",
      body: formData,
    });
    const { sections } = await response.json();
    for (const [key, value] of Object.entries(sections)) {
      document.querySelector(`#${key}`).innerHTML =
        new DOMParser().parseFromString(
          value,
          "text/html",
        ).body.firstChild.innerHTML;
    }
  }
}

customElements.define("cart-item", CartItem);
